import React from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import Login from "./page/login/login";
import RouterPage from "./page/router";
import SignUp from "./page/login/sign-up";
import RespuestasChecklistExternoPage from "./page/externo/respuestas-checklist-externo";
import AprobarRiesgoViajeExternoPage from "./page/externo/viaje/aprobar-riesgo-viaje-externo";
import EstadoViajeExternoPage from "./page/externo/viaje/estado-viaje-externo";

const RouterMain = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/login">
        <Login />
      </Route>
      <Route exact path="/sign-up">
        <SignUp />
      </Route>
      <Route path="/externo/:id/:idEmpresa">
        <RespuestasChecklistExternoPage />
      </Route>
      <Route exact path="/viaje/:idViaje/:idPersona">
        <AprobarRiesgoViajeExternoPage />
      </Route>
      <Route exact path="/estado-viaje/:idViaje">
        <EstadoViajeExternoPage />
      </Route>
      <Route path="/">
        <RouterPage />
      </Route>
    </Switch>
  </BrowserRouter>
);

export default RouterMain;
